module.exports = __webpack_public_path__ + "img/dental-office-tour-mural.752c1c3b.jpeg";